import React from "react";
import DeviceOverviewBase from "../DeviceOverview";

/**
 * Depo (storage) firma kullanıcıları için cihaz listesi kabuğu.
 * Ağır liste/kart mantığı paylaşılan `DeviceOverview` çekirdeğinde kalır;
 * bu kabuk yalnızca rol bağlamını (isDealer=false) sabitler ve rol-özel
 * ayarlamalar için tek giriş noktası sağlar.
 */
export default function StorageDeviceOverview(props) {
  return <DeviceOverviewBase {...props} isDealer={false} />;
}
